import React from 'react';
import PropTypes from 'prop-types';
import styles from './Breadcrumb.module.scss';

const DefaultSeparator = '›';

const Breadcrumb = ({ items, url, separator, onClick }) => (items ?
    <nav className={styles['breadcrumb-component']}>
        <ol>
            {
                items.map((item, i) => item.url ?
                    <li key={i}
                        className={`${styles['breadcrumb-item']} ${item.hidden ? styles['hidden'] : ''}`}>
                        <a onClick={() => onClick && onClick()}
                           href={`${url}${item.url}`} title={item.name}>
                            <span>{item.name}</span>
                            {i < items.length - 1 && <span className={styles.separator}>{separator || DefaultSeparator}</span>}
                        </a>
                    </li>
                    :
                    <li key={i} className={`${styles['breadcrumb-item']} ${item.hidden ? styles['hidden'] : ''}`}>
                        <span>{item.name}</span>
                        {i < items.length - 1 && <span className={styles.separator}>{separator || DefaultSeparator}</span>}
                    </li>
                )
            }
        </ol>
    </nav> : null
);

Breadcrumb.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        hidden: PropTypes.bool,
    })),
    url: PropTypes.string,
    separator: PropTypes.string,
    onClick: PropTypes.func,
};

export default Breadcrumb;
